import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const riskAssessmentLogService = createApi({
    reducerPath: 'riskAssessmentLogService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['Entity'],
    endpoints: (builder) => ({
        getAllWithPagination: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskAssessmentLogsController.getAllWithPagination}/${body.page}/${body.offset}?orderBy=${body.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskAssessmentLogsController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        save: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskAssessmentLogsController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        update: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskAssessmentLogsController.update}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        delete: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskAssessmentLogsController.delete}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAll: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskAssessmentLogsController.getAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        downloadLogReport: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskAssessmentLogsController.downloadReport}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                    responseHandler: (response) => response.blob(),
                    responseType: 'blob',
                }
            }
        }),
    })
});
export const {
    useGetAllWithPaginationMutation,
    useGetByIdMutation,
    useSaveMutation,
    useUpdateMutation,
    useDeleteMutation,
    useGetAllMutation,
    useDownloadLogReportMutation
} = riskAssessmentLogService;